import React from 'react'
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import CspNotesIcon from 'app/assets/images/IconImages/CspNotesIcon.svg';
import CspNotesDisabledIcon from 'app/assets/images/IconImages/CspNotesDisabledIcon.svg';
import { ff_credentialing_csp_web, ff_credentialing_csp_classic } from 'app/constants/FeatureFlags/Placement/Keys';
import { useDecision } from '@optimizely/react-sdk';
import { CustomTooltip } from '@AMIEWEB/Common/Tooltips';
import { placementDetailsAction } from 'store/redux-store/placement-details/slice';
import { Box } from '@mui/material';
import { theme } from 'styles/global-styles';
import { Cancel } from '@AMIEWEB/Common/CancelModal/Cancel';
import { selectComplianceStatusProgressNotes } from 'store/redux-store/placement-details/selectors';

const useStyles = makeStyles()({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        cursor: 'pointer',
    },
    disabled: {
        fill: theme.palette.disabled.main,
    },
});

const ComplianceStatusProgressNotesIcon = () => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const params = useParams<{ placementId: string }>();
    const { cancelled } = useSelector(
        selectComplianceStatusProgressNotes,
    );
    const [credentialing_csp_classic] = useDecision(ff_credentialing_csp_classic);
    const [credentialing_csp_web] = useDecision(ff_credentialing_csp_web);


    const handleOpenDrawer = () => {
        dispatch(placementDetailsAction.toggleComplianceStatusNotesDrawerState(true));
        dispatch(placementDetailsAction.getComplianceStatusProgress({ placementId: parseInt(params.placementId) }));
    };

    const yesAction = () => {
        dispatch(placementDetailsAction.toggleComplianceStatusNotesDrawerNoteTextboxExpanded(false));
        dispatch(placementDetailsAction.toggleComplianceStatusNotesDrawerNoteCancel(false));
        dispatch(placementDetailsAction.toggleComplianceStatusNotesDrawerClearForm(true));
    };

    const noAction = () => {
        dispatch(placementDetailsAction.toggleComplianceStatusNotesDrawerNoteCancel(false));
    };

    return (
        <>
            {credentialing_csp_classic?.enabled || credentialing_csp_web?.enabled ? (
                <Box className={classes.root} onClick={() => handleOpenDrawer()}>
                    <CustomTooltip standardMargin tooltipContent={t('placement.profile.complianceStatusProgress.toolTipContent')}>
                        <img src={CspNotesIcon} alt="CspNotesIcon" />
                    </CustomTooltip>
                </Box>
            ) : (
                <Box className={classes.root}>
                    <img src={CspNotesDisabledIcon} alt="CspNotesDisabledIcon" className={classes.disabled} />
                </Box>
            )}
            <Cancel openDialog={cancelled} handleConfirmAction={yesAction} handleCancelAction={noAction} />
        </>
    )
}

export default ComplianceStatusProgressNotesIcon